/**
 * Lace & Luna — GB hard block for uk-blocked products (client-side safety net).
 * Server-side Liquid is primary; this catches AJAX search/recommendations and cart adds.
 */
(function () {
  const GB = new Set(['GB', 'UK']);
  const config = window.LaceLocalization || {};
  const country = String(config.country || '').toUpperCase();
  if (!GB.has(country)) return;

  function hideBlocked(root) {
    (root || document).querySelectorAll('[data-uk-blocked="true"]').forEach((el) => {
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
      el.style.display = 'none';
      const gridItem = el.closest('.grid__item, .predictive-search__list-item, li');
      if (gridItem) {
        gridItem.setAttribute('hidden', '');
        gridItem.style.display = 'none';
      }
    });
  }

  function blockAddToCart(event) {
    const form = event.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    if (form.closest('[data-uk-blocked="true"]') || document.body.dataset.laceUkBlockedProduct === 'true') {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  function patchFetch() {
    if (window.__laceUkBlockedFetchPatched) return;
    window.__laceUkBlockedFetchPatched = true;
    const nativeFetch = window.fetch.bind(window);
    window.fetch = function patchedFetch(input, init) {
      const url = typeof input === 'string' ? input : input?.url || '';
      if (url.includes('/cart/add')) {
        return nativeFetch(input, init).then((response) => {
          if (document.body.dataset.laceUkBlockedProduct === 'true') {
            return Promise.reject(new Error('Product unavailable for UK delivery'));
          }
          return response;
        });
      }
      return nativeFetch(input, init);
    };
  }

  function init() {
    hideBlocked();
    patchFetch();
    document.addEventListener('submit', blockAddToCart, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        hideBlocked(node.matches?.('[data-uk-blocked="true"]') ? node.parentElement : node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
